query GetDidsForAccount(
  $id: ID!
  $first: Int
  $last: Int
  $after: String
  $before: String
  $query: String
  $queryList: [QueryItemInput!]
) {
  didsForAccount(
    accountId: $id
    first: $first
    last: $last
    after: $after
    before: $before
    query: $query
    queryList: $queryList
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        id
        insertedAt
        updatedAt
        number
        isByon
        type
        mmsEnabled
        smsEnabled
  
        autoResponse {
          id
        }
        account {
          id
          name
        }
      }
    }
  }
}
